<div class="ki-vorschlag-dialog">
  <button
    type="button"
    class="ki-vorschlag-dialog__overlay"
    tabindex="-1"
    [attr.aria-label]="'ki.vorschlagDialog.abbrechen' | translate"
    (click)="abgebrochen.emit()"
  ></button>
  <div
    class="ki-vorschlag-dialog__fenster"
    role="dialog"
    aria-modal="true"
    data-testid="ki-vorschlag-dialog"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-labelledby]="titelId"
    (keydown.escape)="escape($event)"
  >
    <div class="ki-vorschlag-dialog__kopf">
      <app-ki-mark [size]="24" />
      <div>
        <h2 class="ki-vorschlag-dialog__titel" [id]="titelId">{{ 'ki.vorschlagDialog.titel' | translate }}</h2>
        <div class="ki-vorschlag-dialog__kontext">{{ kontext() }}</div>
        @if (kriterium(); as kriterium) {
          <div class="ki-vorschlag-dialog__kontext" data-testid="ki-vorschlag-kriterium">
            {{ 'ki.vorschlagDialog.fuerKriterium' | translate: { kriterium } }}
          </div>
        }
      </div>
    </div>
    <div class="ki-vorschlag-dialog__inhalt">
      <p class="ki-vorschlag-dialog__erklaerung">{{ 'ki.vorschlagDialog.erklaerung' | translate }}</p>
      <div>
        <label class="ki-vorschlag-dialog__label" [for]="hinweisId">
          {{ 'ki.vorschlagDialog.hinweisLabel' | translate }}
        </label>
        <input
          type="text"
          class="ki-vorschlag-dialog__eingabe"
          data-testid="ki-vorschlag-hinweis"
          [id]="hinweisId"
          [attr.maxlength]="maxLaenge"
          [placeholder]="'ki.vorschlagDialog.hinweisPlaceholder' | translate"
          [value]="hinweis()"
          (input)="eingabe($event)"
          (keydown.enter)="enter($event)"
        />
      </div>
    </div>
    <div class="ki-vorschlag-dialog__fuss">
      <button
        mat-stroked-button
        type="button"
        class="ki-vorschlag-dialog__abbrechen"
        data-testid="ki-vorschlag-abbrechen"
        (click)="abgebrochen.emit()"
      >
        {{ 'ki.vorschlagDialog.abbrechen' | translate }}
      </button>
      <button
        mat-flat-button
        type="button"
        class="ki-vorschlag-dialog__erzeugen"
        data-testid="ki-vorschlag-erzeugen"
        [disabled]="zuLang()"
        (click)="absenden()"
      >
        {{ 'ki.vorschlagDialog.erzeugen' | translate }}
      </button>
    </div>
  </div>
</div>
